import { DropTarget } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
export default DropTarget(function (_ref) {
  var accepts = _ref.accepts;
  return accepts || [NativeTypes.FILE];
}, {
  drop: function drop(props, monitor) {
    if (monitor) {
      var _monitor$getItem = monitor.getItem(),
          files = _monitor$getItem.files;

      props.onDrop(files, monitor);
    }
  }
}, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
});